export default [
    {
        path: "/jsonAsset/:dataType/:id",
        name: "asset",
        props: true,
        component: () => import("../../components/asset/Asset.vue"),
    },

]